module.exports = __webpack_public_path__ + "img/中国铁路西安局有限公司.8879b051.jpg";